import script from "./CampaignCreation.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignCreation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__